'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultNode = null;

var setDefaultNode = exports.setDefaultNode = function setDefaultNode(node) {
  defaultNode = node;
};

var getDefaultNode = exports.getDefaultNode = function getDefaultNode() {
  return defaultNode || document.body;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/RootNode.js
// module id = 84
// module chunks = 0